import { LoginResponse, OmisUser, SignInCredential, SignInResponse, TimeSlotUser, UserAuth } from './../../../models/data/user.model';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WebClientService } from 'src/app/api/client/web-client.service';
import { Register } from 'src/app/models/data/register.model';
import { GetStaticBody, User, UserCredential } from 'src/app/models/data/user.model';
import { APILoginRequest} from 'src/app/models/interfaces/api-user.interface';
import { APIEndpoint } from 'src/app/models/options/api-endpoint';
import { ClientService } from '../../client/client.service';

@Injectable()
export class ApiUserService extends ClientService {

  constructor(
    protected web: WebClientService,
  ) {
    super(web)
  }

  timeslotSignIn$ = (body:SignInCredential):Observable<LoginResponse> => {
    return this.post<LoginResponse>(APIEndpoint.TIMESLOT_LOG_IN,{},body)
  }

  fetchTsmsUserInfo$ = ():Observable<TimeSlotUser> => {
    return this.get<TimeSlotUser>(APIEndpoint.ACCOUNT_INFO,{})
  }
}

